import { BarChartBig } from 'lucide-react';

import { EmptyState, EmptyStateCircles, EmptyStateContent, EmptyStateDescription, EmptyStateTitle } from '@/components/ui/empty-state';
import { FeaturedIcon } from '@/components/ui/featured-icon';

interface GradesEmptyStateProps {
  description: string;
  title?: string;
}

export default function GradesEmptyState({ description, title = 'Brak ocen' }: GradesEmptyStateProps) {
  return (
    <EmptyState className={'w-full'}>
      <EmptyStateCircles />
      <FeaturedIcon size={'lg'}>
        <BarChartBig />
      </FeaturedIcon>
      <EmptyStateContent>
        <EmptyStateTitle>{title}</EmptyStateTitle>
        <EmptyStateDescription>{description}</EmptyStateDescription>
      </EmptyStateContent>
    </EmptyState>
  );
}
